export enum EnumExtraFeeType {
    EXTRA_FEE = 'EXTRA_FEE',
    QUANTITY_EXTRA_FEE = 'QUANTITY_EXTRA_FEE',
    PERCENTAGE_EXTRA_FEE = 'PERCENTAGE_EXTRA_FEE'
}
